import React, { useState, memo } from "react";
import {
	Form, Button,
	ProgressBar
} from "react-bootstrap";
import Sound from 'react-sound';
import { s3base } from "api.js";
import HeadsetCheckImage from "../../../assets/images/HeadphoneNewCheck.png";

const HeadsetCheck = ({ setNextFlag }) => {
	 const [soundStatus, setSoundStatus] = useState(false);
  const [volume, setVolume] = useState(100);
  const [soundPer, setSoundPer] = useState(0);

  const onSound = () => setSoundStatus(true);
  
  const offSound = () => {
    setSoundStatus(false);
    setNextFlag(true);
  };

  const handleSongFinishedPlaying = () => {
    setSoundStatus(false);
    setNextFlag(true);
  };

  const handleSongPlaying = (obj) => {
    setSoundPer((obj.position * 100) / obj.duration);
  };

  const changeRange = (e) => setVolume(e.target.value);

  return (
    <div className="col-xs-12 successContent justify-content-start mock-resource-text">
      <div className="row">
        <div className="col-sm-8">
          <h4 className="mt-0">Headset check</h4>
          <h6>This is an opportunity to check that your headset is working correctly</h6>
          <ol style={{ listStyle: "auto" }}>
            <li>Put your headset on and adjust it so that if it's comfortably over your ears</li>
            <li>When you are ready. cilck on the play button. You hear a short recording</li>
            <li>If you do not hear anything in your headphones while the status reads Playing. Raise your hand to get the attention of the Test Administator</li>
          </ol>
          <div className="currentStatus d-flex justify-content-center align-items-center p-0 audio-player-section">
            <div className="w-100 text-white p-4">
              <div className="d-flex justify-content-center align-items-center w-100 gap-2">
                {soundStatus ? (
                  <button className="bg-transparent text-white border-0" onClick={offSound}>
                    <i className="fa fa-stop" aria-hidden="true"></i>
                  </button>
                ) : (
                  <button className="bg-transparent text-white border-0" onClick={onSound}>
                    <i className="fa fa-play" aria-hidden="true"></i>
                  </button>
                )}
                <div className="flex-grow-1 mt-4">
                  <ProgressBar now={soundPer} style={{ backgroundColor: "#e9ecef", height: "15px" }} variant="primary" />
                  <p style={{ fontSize: "11px" }}>Click the play button to start</p>
                </div>
              </div>
              <br />
              <div className="w-100 d-flex justify-content-center align-items-center">
                <div className="d-flex justify-content-center gap-3 align-items-center w-50">
                  <i className="fa fa-volume-up" aria-hidden="true"></i>
                  <Form.Range min={0} max={100} step={1} defaultValue={volume} onChange={changeRange} />
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="col-sm-4">
          <div className="testingImgOuter">
            <img src={HeadsetCheckImage} alt="headset" />
          </div>
        </div>
      </div>
      <div className="note w-100">
        <ul>
          <li className="list-unstyled">During the test you will not have Play and Stop buttons. The audio recording will start playing automatically</li>
          <li className="list-unstyled">Please do not remove your headset. You should wear it throughtout the test</li>
        </ul>
      </div>
      {soundStatus && (
        <Sound
          url={s3base + "/ptedata/ptemedia/AUD (2)_1539694341.mp3"}
          playStatus={Sound.status.PLAYING}
          onFinishedPlaying={handleSongFinishedPlaying}
          onPlaying={handleSongPlaying}
          volume={volume}
        />
      )}
    </div>
  );
}

export default HeadsetCheck;